import { render, staticRenderFns } from "./quotation-analytics.vue?vue&type=template&id=b3992bfe&"
import script from "./quotation-analytics.vue?vue&type=script&lang=js&"
export * from "./quotation-analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports